import React, { useContext, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExchangeAlt, faExpandAlt } from '@fortawesome/free-solid-svg-icons';
import useFeatureList from '../hooks/useFeatureList';
import { APP_BUNDLES } from '../../app_constant';
import { STRINGS } from '../constant';
import { useLocation } from 'react-router-dom';
import { getThemeHoverBgColor, getThemeTextColor } from '../utils/themeUtils';
import { LAWarningPopup } from '.';
import ChangeExam from "./popup/ChangeExam";
import { createLogger } from '../utils/logger';
import { AuthContext } from '../context/AuthProvider';

const menuItemVariants = {
  hover: {
    scale: 1.03,
    transition: {
      type: 'spring',
      stiffness: 300,
    },
  },
};
// { availableExams, setSwitchPopup, setLayoutState, getPrimaryColor }
const SwitchExamButton = ({ theme, currentTheme }) => {
  const [availableExams, setAvailableExams] = useState([]);
  const [switchPopup, setSwitchPopup] = useState(false);
  const location = useLocation();
  const { loggingEnabled } = useContext(AuthContext);
  const logger = createLogger(loggingEnabled);
  const [layoutState, setLayoutState] = useState({
    isReset: false,
    changeFont: false,
  });
  const featureList = useFeatureList();

  const getPrimaryColor = () => {
    return currentTheme === 'light'
      ? theme?.primary?.light
      : theme?.primary?.dark;
  };

  useEffect(() => {
    const loadExams = async () => {
      try {
        logger.log('Loading exams...');
        const exams = await APP_BUNDLES;
        logger.log('Available exams:', exams);
        logger.log('Number of exams:', exams.length);
        setAvailableExams(exams);
      } catch (error) {
        logger.error('Error loading exams:', error);
      }
    };
    loadExams();
  }, []);

  // Button style with theme colors
  const buttonStyle = {
    backgroundColor: 'transparent',
    transition: 'background-color 0.2s ease',
    color: getThemeTextColor(theme, currentTheme),
    borderRadius: '9999px', // Full rounded
  };

  return (<>
    {featureList?.global.switch_exam && <>

      {switchPopup && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <LAWarningPopup
            options={[STRINGS.no, STRINGS.yes]}
            title={STRINGS.test_exit_warning}
            onCancle={() => {
              setSwitchPopup(false);
            }}
            onPress={(e, index) => {
              if (index === 0) {
                setSwitchPopup(false);
              } else {
                setLayoutState((prev) => ({ ...prev, isReset: true }));
              }
            }}
          />
        </motion.div>
      )}

      {layoutState?.isReset && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <ChangeExam
            state={layoutState}
            onCancle={() => {
              setLayoutState((prev) => ({ ...prev, isReset: false }));
            }}
            onPress={(e, index) => { }}
            options={["change"]}
            title={STRINGS.change_bundle}
            desc={STRINGS.change_bundle_messge}
          />
        </motion.div>
      )}
      
      {availableExams.length > 1 && (
        <div
          className="flex flex-col items-center"
        >
          <button
            className="w-10 h-10 flex items-center justify-center"
            style={buttonStyle}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = getThemeHoverBgColor(theme, currentTheme);
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}   
            onClick={() => {
              if (location?.pathname === "/test") {
                setSwitchPopup(true);
              } else {
                setLayoutState((prev) => ({ ...prev, isReset: true }));
              }
            }}
          >
            <FontAwesomeIcon
              icon={faExchangeAlt}
              className="text-sm"
              style={{ color: getThemeTextColor(theme, currentTheme) }}
            />
          </button>
          <span
            className="text-xs mt-1"
            style={{ color: getThemeTextColor(theme, currentTheme) }}
          >
            Switch Exam
          </span>
        </div>
      )}

      
    </>}
  </>
  );
};

export default SwitchExamButton;
